const lang = {
    en : {
        search : "Search",
        gptSearchPlaceholder : 'What You like to watch today'
    },
    hin : {
        search : "खोज",
        gptSearchPlaceholder : 'आज आप क्या देखना पसंद करते हैं'
    },
    spanish : {
        search : "buscar",
        gptSearchPlaceholder : 'Lo que te gusta ver hoy'
    },
}

export default lang ;